import React from 'react';

const images = {
    clipboard: require('shared_img/icons/clipboard.svg'),
};

const FileList = ({ list }) => {
    return (
        <div className="file-list">
            {list.map(({ id, description, url, ext, size }) => (
                <div key={id} className="file-list__item">
                    <div className="file-list__container">
                        <div className="file-list__icon">
                            <img src={images.clipboard} alt="" />
                        </div>
                        <div className="file-list__info">
                            <a href={url} target="_blank" className="file-list__link">{description}</a>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FileList;
